import { useQuery } from '@tanstack/react-query';
import { getUserDataQuery } from 'api/userApi';
import Loading from 'pages/components/Loading';
import PropTypes from 'prop-types'; // Import PropTypes module
import React, { createContext, useContext } from 'react';

export const UserContext = createContext();
export const useUser = () => useContext(UserContext);

export function UserContextProvider({ children }) {
  const { data, isLoading } = useQuery({
    queryKey: ['userData'],
    queryFn: getUserDataQuery
  });

  if (isLoading) {
    return <Loading />;
  }

  return <UserContext.Provider value={data}>{children}</UserContext.Provider>;
}

// Add 'children' to props validation
UserContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};
